import type { NodeSn } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { destroyPathLookupPathInspectorNode } from './destroyPathLookupPathInspectorNode';
import { setPathInspectorActiveNode } from './setPathInspectorActiveNode';

export interface UpdatePathLookupPathInspectorNodeCommand {
  followingNodeSn?: NodeSn | null;
  previousNodeSn: NodeSn | null;
}

/**
 * Remove node from path inspector and activate other existing path inspector node
 */
export const updatePathLookupPathInspectorNode: GraphCommandFactory<
  UpdatePathLookupPathInspectorNodeCommand
> = (_cmdContext, dispatch) => (command) => {
  if (command.previousNodeSn !== null) {
    dispatch(destroyPathLookupPathInspectorNode, {
      nodeSn: command.previousNodeSn,
    });
  }

  dispatch(setPathInspectorActiveNode, {
    nodeSn: command.followingNodeSn ?? null,
  });
};
